export const SHARED_OFFER_DETAILS_KEY = 'shared_offer_details'
